import Vue from 'vue'
import { Notification } from 'element-ui'
function playAudio(myAudio) {
  myAudio.play()
}
let myAudioSrc = 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/audio/dd.mp3'
let state = {
  websocket: null,
  posData: {},
  multData: {},
  timeoutObj: null,
  lockReconnect: false,
  timeoutnum: null,
  alarmMsgCount: 0,
  unreadCount: 0,
  uploadData: null,
  monitorType: {},
  ioData: {},
}
let mutations = {
  STAFF_UPDATEWEBSOCKET(state, websocket) {
    state.websocket = websocket
  },
  STAFF_UPDATEPOSDATA(state, data) {
    state.posData = data
  },
  STAFF_UPLOADVIDEO(state, data) {
    state.uploadData = data
  },
  STAFF_UPDATEMULTDATA(state, data) {
    state.multData = data
  },
  UPDATA_ALARMCOUNT(state, data) {
    state.alarmMsgCount = data
  },
  UPDATA_UNREADCOUNT(state, data) {
    console.log('data', data)
    state.unreadCount = data
  },
  UPDATA_MONITORTYPE(state, data) {
    state.monitorType = data
  },
  UPDATA_IODATA(state, data) {
    state.ioData = data
  },
}
let actions = {
  STAFF_WEBSOCKET({ commit }) {
    new Promise((resolve) => {
      let clientID = Vue.ls.get('socketClientID'),
        socketURL = process.env.VUE_APP_SOCKET
      commit('STAFF_UPDATEWEBSOCKET', new WebSocket(`${socketURL}/${clientID}`))
      // 只有定义了onopen方法，才能继续实现接收消息，即在使用的地方调用onmessage方法。
      state.websocket.onopen = () => {
        state.timeoutObj && clearInterval(state.timeoutObj)
        state.timeoutObj = setInterval(() => {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          if (state.websocket.readyState == 1) {
            //如果连接正常
            state.websocket.send('h')
          }
        }, 5000)
      }
      state.websocket.onerror = (event) => {
        actions.reconnect({ commit })
      }
      state.websocket.onclose = (event) => {
        actions.reconnect({ commit })
      }
      state.websocket.onmessage = (data) => {
        let msgData
        try {
          msgData = JSON.parse(data.data)
          if (msgData.type == 'messageCount') {
            myAudioSrc = 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/audio/message.wav'
            document.getElementById('myAudio').src = myAudioSrc
            playAudio(document.getElementById('myAudio'))
            commit('UPDATA_ALARMCOUNT', msgData.count)
          } else if (msgData.type == 'timeMonitor') {
            commit('STAFF_UPDATEPOSDATA', msgData.data)
          } else if (msgData.type == 'alarmCount') {
            myAudioSrc = 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/audio/warning.wav'
            document.getElementById('myAudio').src = myAudioSrc
            playAudio(document.getElementById('myAudio'))
            // commit('UPDATA_UNREADCOUNT', msgData.count)
          } else if (msgData.type == 'multMonitor') {
            commit('STAFF_UPDATEMULTDATA', msgData.data)
          } else if (msgData.type == 'avideoUpload') {
            commit('STAFF_UPLOADVIDEO', msgData.data)
          } else if (msgData.type == 'asConfigParam') {
            commit('UPDATA_MONITORTYPE', msgData.data)
          } else if (msgData.type == 'ioStatus') {
            commit('UPDATA_IODATA', msgData.data)
          }
        } catch (error) {
          if (data.data.indexOf('您有新的') != -1) {
            Notification({
              title: '消息',
              offset: 100,
              duration: 0,
              iconClass: 'el-icon-warning-outline',
              customClass: 'wsNotification',
              dangerouslyUseHTMLString: true,
              message: `<span style="color: #333">${data.data}</span>`,
              type: 'success',
            })
            myAudioSrc = 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/audio/dd.mp3'
            document.getElementById('myAudio').src = myAudioSrc
            playAudio(document.getElementById('myAudio'))
          }
        }
      }
      resolve()
    })
  },
  reconnect({ commit }) {
    if (state.lockReconnect) {
      return
    }
    state.lockReconnect = true
    //没连接上会一直重连，设置延迟避免请求过多
    state.timeoutnum && clearTimeout(state.timeoutnum)
    state.timeoutnum = setTimeout(() => {
      //新连接
      actions.STAFF_WEBSOCKET({ commit })
      state.lockReconnect = false
    }, 500)
  },
}

export default {
  state,
  mutations,
  actions,
}
